import React, {Component} from 'react'

import '../styles/style.scss'
import Layout from './Layout'
import TagSelector from './TagSelector'
import {Scrollbars} from 'react-custom-scrollbars';

class Gallery extends Component {
    _isMounted = false

    state = {
        images: [],
        holes: [],
        biggerImages: [],
        rectImage: [],
        selectedTags: [],
        selectedParent: {value: 'All 3D renderings', label: 'All 3D renderings'},
        tagSelectorHeight: 0,
        scrollTop: true,
        scrollHeight: 0,
        spacing: 10,
        percent: 15,
        rectPercent: 40,
        width: 0,
        height: 0,
        parentTags: [],
        normalSize: 150,
        loading: true,
        rules: [
            {
                maxSize: 426,
                numberOfCol: 2
            },
            {
                maxSize: 468,
                numberOfCol: 3
            },
            {
                maxSize: 648,
                numberOfCol: 4
            },
            {
                maxSize: 1024,
                numberOfCol: 5
            },
            {
                maxSize: 1440,
                numberOfCol: 7
            }, {
                unlimited: true,
                numberOfCol: 9
            }
        ]
    }

    gallery = React.createRef()
    scrollBars = React.createRef()

    componentDidMount() {
        this._isMounted = true
        const {app, maxHeight, maxWidth, match} = this.props
        const {rules} = this.state

        app.service('gallery-setting').find({}).then((settings) => {
            let spacing = this.state.spacing
            let percent = this.state.percent
            let rectPercent = this.state.rectPercent
            let rules = this.state.rules
            settings.forEach((setting) => {
                switch (setting.name) {
                    case 'spacing':
                        spacing = setting.value
                        break
                    case 'percent':
                        percent = setting.value
                        break
                    case 'rectPercent':
                        rectPercent = setting.value
                        break
                    case 'rules':
                        rules = setting.value
                        break
                    default:
                        break
                }
            })
            if (this._isMounted) {
                this.setState({spacing, percent, rectPercent, rules})
            }
        })

        app.service('gallery-setting').on('patched', setting => {
            switch (setting.name) {
                case 'spacing':
                    if (this.state.spacing !== setting.value) {
                        this.setState({spacing: setting.value}, this.resize)
                    }
                    break
                case 'percent':
                    if (this.state.percent !== setting.value) {
                        this.setState({percent: setting.value}, this.getBiggerRect)
                    }
                    break
                case 'rectPercent':
                    if (this.state.rectPercent !== setting.value) {
                        this.setState({rectPercent: setting.value}, this.getBiggerRect)
                    }
                    break
                case 'rules':
                    if (this.state.rules !== setting.value) {
                        this.setState({rules: setting.value}, this.resize)
                    }
                    break
                default:
                    break
            }
        })

        app.service('gallery-tags').find({}).then(parentTags => {
            parentTags = parentTags.filter(parentTag => ['5c00f008992a9c7459515e61', '5c00f002992a9c7459515e60'].includes(parentTag._id))
            if (this._isMounted) {
                this.setState({parentTags}, () => {
                    const {parentTags} = this.state
                    const find = parentTags.find(tag => tag.slug === match.params.parentTag)
                    if (find && this._isMounted) {
                        this.setState({selectedParent: {value: find._id, label: find.name}})
                    }
                    this.getImages()
                })
            }
        })

        // Receive real-time events through Socket.io
        app.service('gallery')
            .on('created', this.getImages)

        app.service('gallery')
            .on('patched', this.getImages)

        app.service('gallery')
            .on('removed', this.getImages)

        window.addEventListener('resize', this.resize)
        const width = maxWidth && maxWidth < window.innerWidth ? maxWidth : window.innerWidth
        let numberOfCol = 2
        rules.map(rule => rule.unlimited ? {
            maxSize: Number.POSITIVE_INFINITY,
            numberOfCol: rule.numberOfCol
        } : rule).sort((a, b) => a.maxSize && b.maxSize ? b.maxSize - a.maxSize : 0).forEach(rule => rule.maxSize && width < rule.maxSize ? numberOfCol = rule.numberOfCol : false)
        this.setState({
            width,
            height: maxHeight && maxHeight < this.gallery.current.offsetHeight ? maxHeight : this.gallery.current.offsetHeight,
            normalSize: width / numberOfCol - this.state.spacing,
            numberOfCol
        })
    }

    componentWillUnmount() {
        this._isMounted = false
        const {app} = this.props
        const galleryService = app.service('gallery')
        galleryService.removeListener('created')
        galleryService.removeListener('patched')
        galleryService.removeListener('removed')
        const gallerySetting = app.service('gallery-setting')
        gallerySetting.removeListener('patched')
        window.removeEventListener('resize', this.resize)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.match.params.parentTag !== this.props.match.params.parentTag && prevState.selectedParent === this.state.selectedParent) {
            const {parentTag} = this.props.match.params
            let selectedParent;
            if (!parentTag) {
                selectedParent = {value: 'All 3D renderings', label: 'All 3D renderings'}
            } else {
                const {parentTags} = this.state
                selectedParent = parentTags.find(pTag => pTag.slug === parentTag)
                if (!selectedParent) {
                    selectedParent = {value: 'All 3D renderings', label: 'All 3D renderings'}
                } else {
                    selectedParent = {value: selectedParent._id, label: selectedParent.name}
                }
            }
            this.setState({selectedParent})
        }
    }

    resize = () => {
        const {maxWidth, maxHeight} = this.props
        const {rules} = this.state
        const width = maxWidth && maxWidth < window.innerWidth ? maxWidth : window.innerWidth
        let numberOfCol = 2
        rules.map(rule => rule.unlimited ? {
            maxSize: Number.POSITIVE_INFINITY,
            numberOfCol: rule.numberOfCol
        } : rule).sort((a, b) => a.maxSize && b.maxSize ? b.maxSize - a.maxSize : 0).forEach(rule => rule.maxSize && width < rule.maxSize ? numberOfCol = rule.numberOfCol : false)
        this.setState({
            width,
            height: maxHeight && maxHeight < this.gallery.current.offsetHeight ? maxHeight : this.gallery.current.offsetHeight,
            normalSize: width / numberOfCol - this.state.spacing,
            numberOfCol
        }, this.getItems)
    }

    getImages = async () => {
        this.setState({loading: true})
        const {parentTags} = this.state
        const {app} = this.props
        app.service('gallery').find({}).then((data) => {
            data = data.filter(image => {
                if (!image.parentTag || image.isStandIn) {
                    return true
                }
                if (Array.isArray(image.parentTag)) {
                    for (let tag of image.parentTag) {
                        console.log(tag.value)
                        return ['5c00f008992a9c7459515e61', '5c00f002992a9c7459515e60'].includes(tag.value)
                    }
                    return false
                } else {
                    return ['5c00f008992a9c7459515e61', '5c00f002992a9c7459515e60'].includes(image.parentTag.value)
                }
            })
            const newParentTags = parentTags.map(parentTag => ({
                ...parentTag,
                childrens: {}
            }))
            /*if (!parentTags.find(parentTag => parentTag._id === 'other')) {
                newParentTags.push({
                    name: 'Autres',
                    _id: 'other',
                    childrens: {}
                })
            }*/
            data.forEach(image => {
                if (image.parentTag) {
                    if (Array.isArray(image.parentTag)) {
                        image.parentTag.forEach(pTag => {
                            const parentTag = newParentTags.findIndex(parentTag => parentTag._id === pTag.value)
                            this.calcParent(image, parentTag, newParentTags)
                        })
                    } else {
                        const parentTag = newParentTags.findIndex(parentTag => parentTag._id === image.parentTag.value)
                        this.calcParent(image, parentTag, newParentTags)
                    }
                } else {
                    /*if (image.tag.length > 0) {
                        const other = newParentTags.findIndex(parentTag => parentTag._id === 'other')
                        image.tag.forEach(t => {
                            if (!newParentTags[other].childrens[t]) {
                                newParentTags[other].childrens[t] = 1
                            } else {
                                newParentTags[other].childrens[t] += 1
                            }
                        })
                    } else {
                        image.isStandIn = true
                    }*/
                }
            })
            data.sort((a, b) => a.position - b.position)
            const images = data.filter(image => !image.isStandIn)
            const holes = data.filter(image => image.isStandIn)
            this.getBiggerRect({images, holes, parentTags: newParentTags})
        })
    }

    calcParent = (image, parentTag, newParentTags) => {
        if (parentTag !== -1) {
            if (image.tag.length > 0) {
                image.tag.forEach(t => {
                    if (!newParentTags[parentTag].childrens[t]) {
                        newParentTags[parentTag].childrens[t] = 1
                    } else {
                        newParentTags[parentTag].childrens[t] += 1
                    }
                })
            } else {
                if (!newParentTags[parentTag].childrens['Autres']) {
                    newParentTags[parentTag].childrens['Autres'] = 1
                } else {
                    newParentTags[parentTag].childrens['Autres'] += 1
                }
            }
        } else {
            /*if (image.tag.length > 0) {
                const other = newParentTags.findIndex(parentTag => parentTag._id === 'other')
                image.tag.forEach(t => {
                    if (!newParentTags[other].childrens[t]) {
                        newParentTags[other].childrens[t] = 1
                    } else {
                        newParentTags[other].childrens[t] += 1
                    }
                })
            } else {
                image.isStandIn = true
            }*/
        }
    }

    getBiggerRect = (all) => {
        const {images} = all;
        const {percent, rectPercent} = this.state
        const biggers = images.filter(image => image.bigger)
        const rects = images.filter(image => image.rect)
        const nToShowBigger = Math.round(images.length / 100 * percent) - biggers.length
        const nToShowRect = Math.round(nToShowBigger / 100 * rectPercent) - rects.length
        const biggerImages = this.getRandom(images, nToShowBigger)
        const rectImage = this.getRandom(biggerImages, nToShowRect)
        if (this._isMounted) {
            this.setState({
                biggerImages,
                rectImage, ...all
            }, () => setTimeout(() => {
                if (this._isMounted) {
                    this.setState({loading: false})
                }
            }, 50))
        }
    }

    getRandom = (images, num) => {
        const shuffle = images.filter(image => !image.bigger)
        shuffle.sort(() => {
            return .5 - Math.random();
        })
        return shuffle.splice(0, num)
    }

    handleChange = (tags) => {
        this.setState({selectedTags: tags.map(tag => tag.value)});
    }

    changeParent = (parent) => {
        const {selectedTags, parentTags} = this.state
        const {history} = this.props
        let tags = []
        let name = 'All 3D renderings'
        if (parent.value === 'All 3D renderings') {
            tags = selectedTags
        } else {
            const parentTag = parentTags.find(parentTag => parentTag._id === parent.value)
            name = parentTag.name
            const availableTags = Object.keys(parentTag.childrens)
            for (let i = 0; i < selectedTags.length; i++) {
                if (availableTags.includes(selectedTags[i])) {
                    tags.push(selectedTags[i])
                }
            }
        }
        history.push(parent.value === 'All 3D renderings' ? '/' : `/${parentTags.find(tag => tag._id === parent.value).slug}`)
        this.scrollBars.current.scrollTop(0)
        this.setState({selectedParent: {label: name, value: parent.value}, selectedTags: tags})
    }

    canBeShow = (tags, parentTag, isStandIn) => {
        const {selectedParent, selectedTags} = this.state
        if (!selectedParent || !selectedTags) {
            return selectedParent.value === 'All 3D renderings';
        }
        if (selectedParent.value === 'All 3D renderings' || this.valueCalc(selectedParent.value, parentTag)) {
            if (selectedTags.length === 0 || isStandIn) {
                return true
            } else {
                for (let i = 0; i < tags.length; i++) {
                    if (selectedTags.includes(tags[i])) {
                        return true
                    }
                }
                return false
            }
        } else {
            return false
        }
    }

    valueCalc = (value, parentTag) => {
        if (Array.isArray(parentTag)) {
            const values = parentTag.map(pTag => pTag.value);
            return values.includes(value) || values.includes('all')
        } else {
            return value === parentTag.value || parentTag.value === 'all'
        }
    }

    inside = (imageTags, selTags) => {
        for (let i = 0; i < selTags.length; i++) {
            const selTag = selTags[i]
            if (imageTags.includes(selTag)) {
                return true
            }
        }
        return false
    }

    saveScroll = () => {
        this.scrollTop = this.scrollSave
    }

    setScroll = () => {
        this.scrollBars.current.scrollTop(this.scrollTop)
    }

    render() {
        const {
            images,
            holes,
            biggerImages,
            rectImage,
            selectedTags,
            width,
            normalSize,
            spacing,
            height,
            numberOfCol,
            parentTags,
            selectedParent,
            loading,
            tagSelectorHeight,
            scrollTop
        } = this.state
        const biggerSize = normalSize * 2
        let items = images.map(image => {
            const isRect = (image.rect || !!rectImage.find(rectImg => rectImg._id === image._id)) && numberOfCol > 2
            const isBigger = (image.bigger && !isRect) || (!!biggerImages.find(biggerImage => biggerImage._id === image._id) && !isRect)
            const size = isRect && width > 320 ? biggerSize + normalSize + spacing * 2 : isBigger ? biggerSize + spacing : normalSize
            if (this.canBeShow(image.tag, image.parentTag, false)) {
                return {
                    id: image._id,
                    size,
                    url: image.url,
                    isRect,
                    isBigger,
                    name: image.name,
                    position: image.position,
                    video: image.isVideo ? image.videoUrl : false
                }
            }
            return null
        })
        items = items.filter(item => item !== null)
        let tmpHoles = holes.filter(hole => this.canBeShow(hole.tag, hole.parentTag, true))
        if (tmpHoles.length === 0) {
            tmpHoles = holes
        }
        return (
            <div className={`gallery${loading ? ' loading' : ''}`} no-touch="true" ref={this.gallery}
                 style={{maxWidth: `${width}px`, width: '100vw', height: '100vh'}}>
                <Scrollbars
                    ref={this.scrollBars}
                    onScroll={() => {
                        this.scrollSave = this.scrollBars.current.getScrollTop()
                        if (this.scrollSave !== 0 && scrollTop) {
                            this.setState({scrollTop: false})
                        } else if (this.scrollSave === 0 && !scrollTop) {
                            this.setState({scrollTop: true})
                        }
                    }}
                    autoHide
                    style={{height}}
                >
                    <TagSelector
                        selectedParent={selectedParent}
                        selectedTags={selectedTags}
                        changeParent={this.changeParent}
                        handleChange={this.handleChange}
                        parentTags={parentTags ? parentTags.filter(parentTag => parentTag.childrens && Object.keys(parentTag.childrens).length > 0) : []}
                        onHeightChange={(height) => this.setState({tagSelectorHeight: height})}
                        hide={!scrollTop}
                    />
                    {items.length > 0 ? (
                        <Layout
                            height={height}
                            numberOfCol={numberOfCol}
                            startY={spacing}
                            startX={0}
                            biggerSize={biggerSize}
                            normalSize={normalSize}
                            spacing={spacing}
                            gallery={this.gallery}
                            tagSelectorHeight={tagSelectorHeight}
                            items={items}
                            holes={tmpHoles}
                            resize={this.resize}
                            maxWidth={width}
                            saveScroll={this.saveScroll}
                            setScroll={this.setScroll}
                        />
                    ) : (<h1 className="no_item">Pas d'images correspondant
                        au{selectedTags.length > 1 && 'x'} tag{selectedTags.length > 1 && 's'} selectionner</h1>)}
                </Scrollbars>
            </div>
        )
    }
}

export default Gallery
